import Layout from "@/layout";

const mallRouter = {
  path: "/mall",
  component: Layout,
  redirect: "/mall/list",
  name: "mall",
  meta: {
    title: "商品管理",
    icon: "clipboard"
  },
  children: [
    {
      path: "category",
      component: () => import("@/views/mall/category/index"),
      name: "category",
      meta: { title: "商品分类", icon: "" }
    },
    {
      path: "up",
      component: () => import("@/views/mall/up/index"),
      name: "up",
      meta: { title: "商品上架", icon: "" }
    },
    {
      path: "list",
      component: () => import("@/views/mall/list/index"),
      name: "mallList",
      meta: { title: "商品列表", icon: "" }
    },
    {
      path: "mallTag",
      component: () => import("@/views/mall/mallTag/index"),
      name: "mallTag",
      meta: { title: "商品标签", icon: "" }
    },
    {
      path: "serviceType",
      component: () => import("@/views/mall/serviceType/index"),
      name: "serviceType",
      meta: { title: "服务类型", icon: "" }
    },
    {
      path: "list/creatProduct/:id?",
      component: () => import("@/views/mall/serviceType/createPlan/index"),
      name: "serviceTypeCreat",
      meta: {
        title: "添加/编辑套餐",
        noCache: true,
        activeMenu: `/mall/serviceType`,
        parentPath: `/mall/serviceType`
      },
      hidden: true
    }
  ]
};

export default mallRouter;
